import { makeStyles } from "@material-ui/core/styles";
import { SECONDARY_COLOR } from "../../theme";

export const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 1200,
    margin: "0 auto",
  },
  title: {
    textAlign: "center",
    color: SECONDARY_COLOR,
    borderBottom: "1px dashed black",
    width: "fit-content",
    margin: "0 auto",
    textTransform: "uppercase",
  },
  subtitle: {
    opacity: 0.8,
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
  },
  error: {
    color: "crimson",
  },
  featuredWordContainer: {
    display: "flex",
    justifyContent: "center",
  },
  searchAndResultsWrapper: {
    backgroundColor: "#f8f8f8",
    padding: "32px 0",
  },
  innerWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 24px",
  },
  searchContainer: {
    display: "flex",
    marginBottom: "32px",
    boxSizing: "border-box",
    border: `1px solid ${SECONDARY_COLOR}`,
  },
  searchIcon: {
    position: "absolute",
    display: "block",
    alignSelf: "center",
    fontSize: "1.6rem",
    opacity: 0.5,
    marginLeft: "1rem",
    marginTop: "0.2rem",
    pointerEvents: "none",
  },
  searchInput: {
    width: "100%",
    display: "block",
    boxSizing: "border-box",
    height: "100%",
    border: "none",
    fontSize: "1.5rem",
    fontFamily: "'Lato', sans-serif",
    color: "#000000",
    backgroundColor: "white",
    padding: "0.7rem 3.4rem",
    "&:focus": {
      outline: "none",
    },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: 16,
    maxHeight: "70vh",
    overflowY: "auto",
  },
  noResults: {
    textAlign: "center",
    opacity: 0.7,
    marginTop: "32px",
  },
  sentinel: {
    height: 1,
  },
  loadingContainer: {
    padding: "16px 0",
    textAlign: "center",
  },
  endMessage: {
    opacity: 0.7,
  },
}));
